import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import ReleaseNotesView from './ReleaseNotesView.vue';

// SiteUp: Novidades (mundo Sistema do Hub). Le o arquivo versionado
// helper/releaseNotes.js; nao existe e nao deve existir API para isso.
// O nome NAO pode comecar com `onboarding_`: `isOnOnboardingView` casa esse
// prefixo e o guard do dashboard manda a pessoa para /dashboard (foi o que
// aconteceu com a central de ajuda na v893). O spec releaseNotesRoute prende.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/novidades'),
    name: 'release_notes',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: ReleaseNotesView,
  },
];
